import type { ReactNode } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@runcheetah/ui";
import { cn } from "@/lib/utils";

export interface FilterCardProps {
  title: ReactNode;
  children: ReactNode;
  columnsClassName?: string;
  className?: string;
}

export function FilterCard({
  title,
  children,
  columnsClassName = "md:grid-cols-3",
  className,
}: FilterCardProps) {
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="text-sm">{title}</CardTitle>
      </CardHeader>
      <CardContent className={cn("grid gap-3", columnsClassName)}>{children}</CardContent>
    </Card>
  );
}
